(() => {
  const initDirectory = (root) => {
    if (!root || root.dataset.directoryReady === 'true') return;
    root.dataset.directoryReady = 'true';

    const bridge = String(root.dataset.bridgeUrl || 'https://members.nubsmedia.ca').replace(/\/$/, '');
    const databaseUrl = String(root.dataset.databaseUrl || '/pages/my-collection');
    const facet = String(root.dataset.directoryFacet || '').trim();
    const param = String(root.dataset.directoryParam || '').trim();
    const minimumCount = Math.max(1, Number(root.dataset.directoryMinimumCount || 1) || 1);
    const status = root.querySelector('[data-directory-status]');
    const content = root.querySelector('[data-directory-content]');
    const summary = root.querySelector('[data-directory-summary]');
    const alphabet = root.querySelector('[data-directory-alphabet]');
    const grid = root.querySelector('[data-directory-grid]');
    const sortControl = root.querySelector('[data-directory-sort]');
    const letters = ['#', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];

    const setStatus = (message) => {
      if (!status) return;
      status.textContent = message;
      status.hidden = !message;
    };

    const initialFor = (value) => {
      const first = String(value || '').trim().charAt(0).toUpperCase();
      return /^[A-Z]$/.test(first) ? first : '#';
    };

    const cardHref = (value) => {
      const url = new URL(databaseUrl, window.location.origin);
      url.searchParams.set(param, value);
      return `${url.pathname}${url.search}`;
    };

    const render = (rawValues) => {
      const values = (Array.isArray(rawValues) ? rawValues : [])
        .map((item) => ({value: String(item?.value || '').trim(), count: Number(item?.count || 0)}))
        .filter((item) => item.value && item.count >= minimumCount);

      if (!values.length) {
        setStatus('Nothing is available in this database browse view yet.');
        if (content) content.hidden = true;
        return;
      }

      const available = new Set(values.map((item) => initialFor(item.value)));
      let selectedLetter = '';

      const renderCards = () => {
        const filtered = (selectedLetter
          ? values.filter((item) => initialFor(item.value) === selectedLetter)
          : [...values]);
        const sortMode = String(sortControl?.value || 'alpha-asc');
        filtered.sort((a, b) => {
          if (sortMode === 'alpha-desc') return b.value.localeCompare(a.value, undefined, {sensitivity:'base', numeric:true});
          if (sortMode === 'count-desc') return b.count - a.count || a.value.localeCompare(b.value, undefined, {sensitivity:'base', numeric:true});
          if (sortMode === 'count-asc') return a.count - b.count || a.value.localeCompare(b.value, undefined, {sensitivity:'base', numeric:true});
          return a.value.localeCompare(b.value, undefined, {sensitivity:'base', numeric:true});
        });

        if (summary) {
          if (selectedLetter) {
            summary.textContent = `${filtered.length} ${filtered.length === 1 ? 'option' : 'options'} beginning with ${selectedLetter}`;
          } else {
            summary.textContent = `${values.length} ${values.length === 1 ? 'option' : 'options'}`;
          }
        }

        if (alphabet) {
          alphabet.querySelectorAll('button[data-directory-letter]').forEach((button) => {
            const active = String(button.dataset.directoryLetter || '') === selectedLetter;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        }

        if (grid) {
          const cards = filtered.map((item) => {
            const card = document.createElement('a');
            card.className = 'nubs-directory-card';
            card.href = cardHref(item.value);

            const name = document.createElement('span');
            name.className = 'nubs-directory-card__name';
            name.textContent = item.value;

            const count = document.createElement('span');
            count.className = 'nubs-directory-card__count';
            count.textContent = `${item.count} ${item.count === 1 ? 'release' : 'releases'}`;

            card.append(name, count);
            return card;
          });
          grid.replaceChildren(...cards);
        }
      };

      if (alphabet) {
        const allButton = document.createElement('button');
        allButton.type = 'button';
        allButton.textContent = 'All';
        allButton.dataset.directoryLetter = '';
        allButton.setAttribute('aria-pressed', 'true');
        allButton.addEventListener('click', () => {
          selectedLetter = '';
          renderCards();
        });

        const letterControls = letters.map((letter) => {
          if (!available.has(letter)) {
            const disabled = document.createElement('span');
            disabled.textContent = letter;
            disabled.setAttribute('aria-hidden', 'true');
            return disabled;
          }
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = letter;
          button.dataset.directoryLetter = letter;
          button.setAttribute('aria-pressed', 'false');
          button.addEventListener('click', () => {
            selectedLetter = letter;
            renderCards();
          });
          return button;
        });
        alphabet.replaceChildren(allButton, ...letterControls);
      }

      sortControl?.addEventListener('change', renderCards);
      renderCards();
      setStatus('');
      if (content) content.hidden = false;
    };

    if (!facet || !param) {
      setStatus('This database browse view is not configured correctly.');
      return;
    }

    const requestUrl = new URL(`${bridge}/catalog/releases`);
    requestUrl.searchParams.set('mode', 'directory');
    requestUrl.searchParams.set('facet', facet);
    try {
      const cached = JSON.parse(window.sessionStorage?.getItem('nubs:catalog-hidden-release-ids:v1') || 'null');
      const tokenOnly = JSON.parse(window.sessionStorage?.getItem('nubs:catalog-visibility-token:v1') || 'null');
      const token = cached && Number(cached.expiresAt) > Date.now()
        ? String(cached.visibilityToken || '').trim()
        : tokenOnly && Number(tokenOnly.expiresAt) > Date.now()
          ? String(tokenOnly.visibilityToken || '').trim()
          : '';
      if (token) requestUrl.searchParams.set('visibilityToken', token);
    } catch (_) {}

    (window.NubsCatalogClient ? window.NubsCatalogClient.request(requestUrl) : fetch(requestUrl.toString(), {credentials:'omit',cache:'default',headers:{Accept:'application/json'}}).then(async response => ({ok:response.ok,payload:await response.json().catch(()=>null)})))
      .then(({ok,payload}) => {
        if (!ok || !payload?.ok) throw new Error(payload?.error || 'Unable to load this database directory.');
        render(payload.values);
      })
      .catch((error) => {
        console.error('[Nub browse directory]', error);
        setStatus('This database browse view is temporarily unavailable. Please try again.');
        if (content) content.hidden = true;
      });
  };

  const boot = () => document.querySelectorAll('[data-nubs-directory]').forEach(initDirectory);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('nubs:pagechange', boot);
})();
